const promiseOptions = async (input: string) => {
  const res = await fetch(
    `https://places.googleapis.com/v1/places:autocomplete`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': process.env.REACT_APP_GOOGLE_API_KEY
      } as HeadersInit,
      body: JSON.stringify({
        input,
        sessionToken: '123456'
      })
    }
  )
  const result = await res.json()
  return result.suggestions.map((data: any) => {
    return {
      value: data.placePrediction.placeId,
      label: data.placePrediction.text?.text
    }
  })
}

export const getAddress = async (
  name: string,
  input: {
    value: string
    label: string
  },
  formik: any,
  fields?: string[]
) => {
  if (!input?.value) return
  formik.setFieldValue(name, input.label)
  const res = await fetch(
    `https://places.googleapis.com/v1/places/${input.value}?sessionToken=123456`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': process.env.REACT_APP_GOOGLE_API_KEY,
        'X-Goog-FieldMask':
          'formattedAddress,addressComponents,location,googleMapsUri'
      } as HeadersInit
    }
  )
  const result = await res.json()
  formik.setFieldValue(name, result.formattedAddress)
  if (fields?.includes('latitude'))
    formik.setFieldValue('latitude', result.location.latitude)
  if (fields?.includes('longitude'))
    formik.setFieldValue('longitude', result.location.longitude)
  if (fields?.includes('google_maps_uri'))
    formik.setFieldValue('google_maps_uri', result.googleMapsUri)
  let line1: {
    subpremise?: string
    street_number?: string
    route?: string
  } = {}
  result.addressComponents.forEach((data: any) => {
    ;['subpremise', 'street_number', 'route'].forEach((type) => {
      if (data.types.includes(type)) {
        line1[type as keyof typeof line1] = data.longText
      }
    })
    if (
      fields?.includes('city') &&
      (data.types.includes('locality') ||
        data.types.includes('postal_town') ||
        data.types.includes('sublocality'))
    ) {
      formik.setFieldValue('city', data.longText)
    }
    if (
      fields?.includes('state') &&
      data.types.includes('administrative_area_level_1')
    ) {
      formik.setFieldValue('state', data.longText)
    }
    if (data.types.includes('country')) {
      if (fields?.includes('country'))
        formik.setFieldValue('country', data.longText)
      if (fields?.includes('country_code'))
        formik.setFieldValue('country_code', data.shortText)
    }
    if (fields?.includes('zip_code') && data.types.includes('postal_code')) {
      formik.setFieldValue('zip_code', data.longText)
    }
  })
  if (fields?.includes('address_line1')) {
    const line1Str = [line1.subpremise, line1.street_number, line1.route]
      .filter(Boolean)
      .join(' ')
    formik.setFieldValue('address_line1', line1Str)
  }
}
export const getAddresses = (inputValue: string) =>
  new Promise<{ value: string; label: string }[]>((resolve) => {
    resolve(inputValue ? promiseOptions(inputValue) : [])
  })
